import logger from '../../../utils/logger';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import type { IBatchStore } from '../batch-store-types';
import { timerKey } from '../../../utils/timer-manager/timer-manager';
import { validateAndScheduleDecumScaleDischarge } from './discharge-decum-scale';
import { checkDecumHoldConditions } from './check-decum-hold-conditions';

/**
 * Monitor decum scale weight during discharge
 */
export const monitorDecumScaleWeight = (
  batchStore: IBatchStore,
  data: any,
  initialData: any,
  scaleRef: any,
  scalePorts: { openPort: any; closePort: any; openPortAdditional: any; closePortAdditional: any },
  weight: any,
  reaction: any,
) => {
  const { scale, material } = data;
  const { openPort, closePort, openPortAdditional, closePortAdditional } = scalePorts;
  const sid = `${scale.id}-${material.code}`;
  let s = batchStore.getDeviceStatus(sid);

  if (data.isFeedFinish) {
    logger.log(`DECUM ${sid} already finish!!!`);
    reaction.dispose();
    return;
  }

  if (weight <= 0 && s.finishTarget !== 0) {
    batchStore.showWarning(`Not enough material ${material.code} on the decum scale #${scale.id} !`);

    batchStore.holdFeedDevice(scale.id);
  }

  s = batchStore.getDeviceStatus(sid);

  batchStore.deviceStatus.set(sid, {
    ...s,
    weight: s.startWeight - weight,
  });

  if (checkDecumHoldConditions(batchStore, initialData, scale, scaleRef)) {
    batchStore.setWeight('-', scale.inputPNo, 100000, 100000, 0, closePort);
    batchStore.closeScale(scale, openPort, closePort);
    if (batchStore.isDoubleGateScale(scale)) {
      batchStore.closeScale(scale, openPortAdditional, closePortAdditional);
    }

    const s = batchStore.getDeviceStatus(sid);

    logger.log('Decum hold', sid, s.status);

    if (s.status !== DeviceStatus.FINISH) {
      batchStore.deviceStatus.set(sid, {
        ...s,
        holdWeight: batchStore.getScaleWeight(scale) - s.startWeight,
        status: DeviceStatus.HOLD,
      });

      batchStore.timers.set(timerKey.device(scale.id), () => {
        batchStore.deviceStatus.set(sid, {
          ...s,
          holdWeight: batchStore.getScaleWeight(scale) - s.startWeight,
          status: DeviceStatus.HOLD,
        });

        batchStore.timers.clear(timerKey.device(scale.id));
        validateAndScheduleDecumScaleDischarge(batchStore, data, initialData, scaleRef);

      }, 1500, `Monitor decum scale weight - scale #${scale.id}`); // time needed to close the gate completely
    }

    reaction.dispose();
  }
};
